import { Component, OnInit } from '@angular/core';
import {EventService } from '../../services/event.service';
import { FormService } from 'src/app/services/form.service';
import { FontsService } from 'src/app/services/fonts.service';
import * as moment from 'moment-timezone';
import { environment } from './../../../environments/environment.prod';
import {LanguageService} from './../../services/language.service';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-eventlist',
  templateUrl: './eventlist.component.html',
  styleUrls: ['./eventlist.component.scss'],

})
export class EventlistComponent implements OnInit {

  apiUrl = environment.apiURL;
  eventlist: any;
  show: boolean[] = [];
  hideDescription: boolean[] = [];
  searchstring:any;
  public showSearchResults: boolean;
  defaultSize: number;
  language:any;
  href:string;
  idName:any;
  scrollHref:any;
  edit:boolean=false;

  constructor(private http:HttpClient,private languageService:LanguageService,private eventservice: EventService, private formService: FormService, private fontService: FontsService) {
     
      this.showSearchResults = true;
      this.eventlist = this.getEventsList();
   }

  ngOnInit() {

    this.searchstring = document.URL.split('=')[1];
    // console.log("window.location.href=======>>>>>===========>........."+window.location.href);
    this.languageService.currenLanguage.subscribe((result:any)=>{

      console.log("header",result);
      this.language = result;

    })

    // this.eventlist=this.eventservice.get();
     this.getEventsList();
    this.show[0] = false;
     this.eventservice.outputbystate.subscribe(res => {

          console.log("Event Subscibed");

          //  this.eventlist = eventdatalist;
          //  this.showSearchResults = true;
          for(let i=0;i<res.length;i++){

            res[i].eventStartTime = moment(res[i].eventStartTime, ["h:mm"]).format("h:mm A");
            res[i].eventEndTime = moment(res[i].eventEndTime, ["h:mm"]).format("h:mm A");
            let day = moment(res[i].eventdate).date();
            let date = moment.tz(res[i].eventdate, "YYYY-MM-DD",'UTC');

            // var jun = moment("2014-06-01T12:00:00Z");
            // var dec = moment("2014-12-01T12:00:00Z");

            // jun.tz('America/Los_Angeles').format('ha z');  
            // dec.tz('America/Los_Angeles').format('ha z');  

            // date.tz('UTC');
            let dayNumber =  date.date();
            res[i].day = dayNumber;
          }
          this.eventlist = res;      
          this.showSearchResults = true;

          

     });
 
  }


  ngAfterViewInit(){
   
    // this.href=window.location.href;
    // if(this.href.indexOf("#")){

    //   let indexOfId =this.href.indexOf("#") + 1;
    //   let idLength = this.href.length;
    //   let idName = this.href.substring(indexOfId, idLength);
    //   this.idName = idName;

    //   this.getformInfo();
    //   // console.log(".................................. "+idName);
    //   setTimeout(function() {
    //     let el = document.getElementById(idName);
      
    //      el.scrollIntoView({behavior: 'smooth'});
       
    //   }, 5000);
    // }


  }
  
  getEventsList() {
    this.eventservice.getEvents().subscribe((res) => {
      
      for(let i=0;i<res.length;i++){
        res[i].eventStartTime = moment(res[i].eventStartTime, ["h:mm"]).format("h:mm A");
        res[i].eventEndTime = moment(res[i].eventEndTime, ["h:mm"]).format("h:mm A");
        let day = moment(res[i].eventdate).date();
        let date = moment(res[i].eventdate, "YYYY-MM-DD");

        // var jun = moment("2014-06-01T12:00:00Z");
        // var dec = moment("2014-12-01T12:00:00Z");

        // jun.tz('America/Los_Angeles').format('ha z');  
        // dec.tz('America/Los_Angeles').format('ha z');  

        date.tz('UTC');
        let dayNumber =  date.date();
        res[i].day = dayNumber;
      }
      this.eventlist = res;      
      this.showSearchResults = true;

      ////////////////////////////////////////////////
      this.href=window.location.href;
      if(this.href.indexOf("#")){

        let indexOfId =this.href.indexOf("#") + 1;
        let idLength = this.href.length;
        let idName = this.href.substring(indexOfId, idLength);
        this.idName = idName;

        this.getformInfo();
        // console.log(".................................. "+idName);
        // setTimeout(function() {
          let el = document.getElementById(idName);
        
          el.scrollIntoView({behavior: 'smooth'});
        
        // }, 1000);
      }
      ////////////////////////////////////////////////
    });
    
  }

  toggle(id: number) {
    console.log(id);

    this.show[id] = !this.show[id];
  }

  sucessregister(id: number){
    console.log('sucess');
    this.show[id] = !this.show[id];
    this.hideDescription[id] = false;
  }
  cancelregistration(event: any) {
    this.show[event] = false;
  }

  hidedesc (event: any) {
     // console.log(event);
      this.hideDescription[event] = true;
  }

  onNavigate(adress: string) {
    if(confirm('Please note: You will now be leaving the PAP Registration Portal.'))
    window.open('http://www.google.com/maps/place/' + adress, '_blank');
  }

  public headerStyleObject = (): any => {
    return this.fontService.getHeaderStyleObject();
  }

  public spanPinkStyleObject = (): any => {
    return this.fontService.getSpanPinkStyleObject();
  }

  public header3StyleObject = (): any => {
    return this.fontService.getHeader3StyleObject();
  }

  public header4StyleObject = (): any => {
    return this.fontService.getHeader4StyleObject();
  }

  public header5StyleObject = (): any => {
    return this.fontService.getHeader5StyleObject();
  }

  public topicHeaderStyleObject = (): any => {
    return this.fontService.getTopicHeaderStyleObject();
  }

  public titleStyleObject = (): any => {
    return this.fontService.getTitleStyleObject();
  }


  getformInfo(){

    this.http.get(this.apiUrl + 'attendees/getattendeedetails?searchString='+this.searchstring)
    .subscribe((response:any) => {
     
      if(response.data.length>0){
        this.show[this.idName]=true;
      }
  
     

    }, (err: HttpErrorResponse) => {
        console.log(err);
      
        if (err.status === 409) {
          
        }
    });

}


}
